module.exports = __webpack_public_path__ + "img/logo.87aeda2c.png";